module.exports = __webpack_public_path__ + "img/not_show_without_moderation.6fd60ac7.svg";